import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";

let firebaseConfig = {
  apiKey: "AIzaSyD8KCGdoOIKjLHVK6qlpfhvFRBVmMtLHjw",
  authDomain: "tabletap-908f0.firebaseapp.com",
  projectId: "tabletap-908f0",
  storageBucket: "tabletap-908f0.firebasestorage.app",
  messagingSenderId: "228308829516",
  appId: "1:228308829516:web:eff16411894f70785b3be9",
  measurementId: "G-VX4DLWMPLY",
};

if (process.env.REACT_APP_NODE_ENV !== "production") {
  firebaseConfig = {
    apiKey: "AIzaSyDUEBzfsrlTpqq9OpQS3t6JzFDMCYqybZU",
    authDomain: "tabletapdev.firebaseapp.com",
    projectId: "tabletapdev",
    storageBucket: "tabletapdev.firebasestorage.app",
    messagingSenderId: "592272905586",
    appId: "1:592272905586:web:a1c693ecd371969f2eb9eb",
    measurementId: "G-PCCGBCW75N",
  };
}

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export async function requestPermission() {
  const permission = await Notification.requestPermission();

  if (permission !== "granted") {
    console.warn("Notification permission not granted:", permission);
    return null;
  }
}

// Expose messaging and onMessage so App can listen for foreground messages
export { messaging, onMessage };
